import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import MarkerSearchResultItem from 'components/formula-entry/marker-search-result-item';
import { TConcatArraysReturnType } from '../modals/types';

const { onyx60 } = colors;

const List = styled.ul`
  border: none;
  border-radius: 2px;
  background-color: white;
  height: 388px;
  margin: 0;
  overflow-y: scroll;
  padding: 0px;
`;

const NoMarkersListItem = styled.li`
  font-size: 14px;
  list-style: none;
  color: ${onyx60};
  pointer-events: none;
  text-align: center;
  padding-top: 100px;
`;

interface IMarkerSearchResultsProps {
  onClick: (name: string) => void;
  markers: TConcatArraysReturnType[] | null;
  noResultsMessage?: string;
}

export default ({ onClick, markers, noResultsMessage = 'No markers found' }: IMarkerSearchResultsProps) => {
  return (
    <List>
      {markers?.length ? (
        markers.map((marker: TConcatArraysReturnType) => {
          const { name, types } = marker;
          return (
            <MarkerSearchResultItem
              key={name}
              onClick={() => onClick(name)}
              description={name}
              isFavorite={marker?.isFavorite}
              types={types}
            />
          );
        })
      ) : (
        <NoMarkersListItem>{noResultsMessage}</NoMarkersListItem>
      )}
    </List>
  );
};
